import { Injectable } from '@angular/core'
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class EmpresasService {

    constructor(private http: Http,
                private seguridad: SeguridadService
              ) { }

    getListaEmpresas(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "EmpresaGetEmpresas", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

            console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getSelect(params : any){

      let userToken : string = localStorage.getItem('currentUserToken');

      params.tokenid = userToken;
      params.api_keytoken = AppSettings.API_KEYTOKEN;

      return this.http.post(AppSettings.API_URL, JSON.stringify(params))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getEmpresa(id_empresa:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_empresa: id_empresa, tokenid: userToken, action: "EmpresaGetEmpresa", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getEmpresasEvidencias(id_evidencia:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia, tokenid: userToken, action: "EmpresasEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    getEmpresasEvidenciasDelegados(id_evidencia:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia, tokenid: userToken, action: "EmpresasEvidenciaDelegados", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }       


    getEmpresasNorma(id_norma:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "EmpresasNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    getEmpresasNormaDelegados(id_norma:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "EmpresasNormaDelegados", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }  


    getEmpresasModulo(id_modulo:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "EmpresasModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    getEmpresasModuloDelegados(id_modulo:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "EmpresasModuloDelegados", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }  


    getEvidenciasEquitativas(id: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id: id,  tokenid: userToken, action: "getListaEvidenciasEquitativas", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getAllEvidenciasEquitativas(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({  tokenid: userToken, action: "getAllEvidenciasEquitativas", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setEnlacesEvidencia(id: number, id_nuevo: number, valor: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id: id, id_nuevo:id_nuevo,valor:valor, tokenid: userToken, action: "setEvidenciasEquitativas", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }


    getActividad(id_actividad:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad, tokenid: userToken, action: "ActividadGetListaActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteActividad(id_actividad:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad, tokenid: userToken, action: "ActividadDeleteActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setActividad(actividad:any){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ actividad: actividad, tokenid: userToken, action: "ActividadSetListaActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaActividades(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "ActividadGetListaActividades", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setEmpresa(empresa: any){

      let userToken : string = localStorage.getItem('currentUserToken');

      empresa.tokenid = userToken;
      empresa.action = "EmpresaSetEmpresa";
      empresa.api_keytoken = AppSettings.API_KEYTOKEN;


      return this.http.post(AppSettings.API_URL, JSON.stringify(empresa))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setLogo(formData: FormData){

      let userToken : string = localStorage.getItem('currentUserToken');

      let headers = new Headers();

      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      let options = new RequestOptions({ headers: headers });

      formData.append('tokenid', userToken);
      formData.append('action', "AdminUserSetEmpresa");
      formData.append('api_keytoken', AppSettings.API_KEYTOKEN);

      return this.http.post(AppSettings.API_URL, formData, options)
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
          /*.map(res => res.json())
          .catch(error => Observable.throw(error))
          .subscribe(
              data => console.log('success'),
              error => console.log(error)
          )*/

    }

    setLogoCropped(empresa: any){

      let userToken : string = localStorage.getItem('currentUserToken');

      empresa.tokenid = userToken;
      empresa.action = "EmpresaSetLogoEmpresa";
      empresa.api_keytoken = AppSettings.API_KEYTOKEN;


      return this.http.post(AppSettings.API_URL, JSON.stringify(empresa))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });

    }

    getListaInstalaciones(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "TipoinstalacionesListaInstalaciones", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getInstalacion(id_instalacion: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_instalacion: id_instalacion, tokenid: userToken, action: "TipoinstalacionesGetInstalacion", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setInstalacion(instalacion: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ instalacion: instalacion, tokenid: userToken, action: "TipoinstalacionesSetInstalacion", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteInstalacion(id_instalacion: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_instalacion: id_instalacion, tokenid: userToken, action: "TipoinstalacionesDelInstalacion", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaEquipos(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "TipoEquiposListaEquipos", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteEquipo(id_equipo: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_equipo: id_equipo, tokenid: userToken, action: "TipoEquiposDelEquipo", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setEquipo(equipo: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ equipo: equipo, tokenid: userToken, action: "TipoEquiposSetEquipo", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }


    getEquipo(id_equipo: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_equipo: id_equipo, tokenid: userToken, action: "TipoEquiposGetEquipo", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaTipoCentros(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "TipoCentrosListaCentros", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteTipoCentro(id_tipocentro: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_tipocentro: id_tipocentro, tokenid: userToken, action: "TipoCentrosDelTipoCentro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setTipoCentro(tipocentro: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tipocentro: tipocentro, tokenid: userToken, action: "TipoCentrosSetTipoCentro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }


    getTipoCentro(id_tipocentro: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_tipocentro: id_tipocentro, tokenid: userToken, action: "TipoCentrosGetTipoCentro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaEvidencias(id_tipocentro: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_tipocentro: id_tipocentro, tokenid: userToken, action: "TipoCentrosListaEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    delEvidenciaTipocentro(id_tipocentro: number, id_evidencia: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia, id_tipocentro: id_tipocentro, tokenid: userToken, action: "TipoCentrosDelEvidenciaTipoCentro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setEvidenciaTipoCentro(id_tipocentro: number, id_evidencia: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia, id_tipocentro: id_tipocentro, tokenid: userToken, action: "TipoCentrosSetEvidenciaTipoCentro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    nuevaZona(zona: string, id_empresa: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_empresa: id_empresa, zona: zona, tokenid: userToken, action: "EmpresaNuevaZona", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    eliminarZona(id_zona: number, id_empresa: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_empresa: id_empresa, id_zona: id_zona, tokenid: userToken, action: "EmpresaEliminarZona", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getArea( id_area: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_area: id_area, tokenid: userToken, action: "EmpresaGetArea", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getSubarea( id_subarea: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_subarea: id_subarea, tokenid: userToken, action: "EmpresaGetSubarea", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getZona( id_ct: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, tokenid: userToken, action: "EmpresaGetZona", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    eliminarArea(id_ct: number,  id_area: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, id_area: id_area, tokenid: userToken, action: "EmpresaEliminarArea", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    eliminarAsignacionZona(id_ct: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, tokenid: userToken, action: "EmpresaEliminarAsignacionZona", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    asignarZona(id_ct: number,  id_area: number, id_zona: number, id_subarea: number, nuevaarea: string, nuevazona: string, nuevasubarea: string){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, id_area: id_area, id_zona: id_zona, id_subarea: id_subarea, nuevaarea: nuevaarea, nuevazona: nuevazona, nuevasubarea: nuevasubarea, tokenid: userToken, action: "EmpresaAsignarZona", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    anadirArea(id_ct: number,  id_area: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, id_area: id_area, tokenid: userToken, action: "EmpresaAnadirArea", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    nuevaArea(id_ct: number,  id_zona: number, area: string){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_ct: id_ct, id_zona: id_zona, area: area, tokenid: userToken, action: "EmpresaNuevaArea", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getMapaDocumentalCompleto(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "PNAuditListaEv", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }




}



// WEBPACK FOOTER //
// ./src/app/_services/empresas.service.ts